export default "__VITE_ASSET__c38103f2__"